new Flickity( '.co-shop-section-2-carousel', {
    cellAlign: "left", 
    contain: true, 
    prevNextButtons: true, 
    pageDots: false, 
    wrapAround: true, 
    // autoPlay: 3000,
    on: {
      ready: function() {
        
      }
    }
  });